import { createQueryFactory } from "../query-factory";

export const { useApiHook: useGetZendeskMessagingJwt } = createQueryFactory(
	"getZendeskMessagingJwt",
);
